<template>
    <b-modal
        id="modalDotacao"
        v-model="mostrarModalDotacao"
        @show="preencherForm()"
        @hide="fecharModalDotacao()"
    >
        <div slot="modal-title">
            Dotação Orçamentária -
            <b-badge variant="warning">{{ acao }}</b-badge>
        </div>
        <b-row v-if="acao == 'INSERIR'">
            <b-col sm="12">
                <b-form-group
                    :state="$v.codUnidade.$error ? false: null"
                    invalid-feedback="A unidade é obrigatória"
                >
                    <label>Unidade</label>
                    <model-list-select
                        :list="unidades"                    
                        option-text="codigoNomeUnidade"
                        option-value="codUnidade"
                        v-model="codUnidade"
                        @input="$v.codUnidade.$touch()"
                    ></model-list-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="acao == 'INSERIR'">
            <b-col sm="12">
                <b-form-group
                    :state="$v.codProjeto.$error ? false: null"
                    :invalid-feedback="`O projeto é obrigatório${this.codUnidade == null ? ', selecione a unidade primeiro' : ''}`"
                >
                    <label>Projeto</label>
                    <model-list-select
                        :list="projetos"                    
                        option-text="codigoNomeProjeto"
                        option-value="codProjeto"
                        v-model="codProjeto"
                        @input="$v.codProjeto.$touch()"
                        :isDisabled="codUnidade == null"
                    ></model-list-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="acao == 'INSERIR'">
            <b-col sm="12">
                <b-form-group
                    :state="$v.codAcao.$error ? false: null"
                    :invalid-feedback="`A ação é obrigatória${this.codProjeto == null ? ', selecione o projeto primeiro' : ''}`"
                >
                    <label>Ação</label>
                    <model-list-select
                        :list="acoes"                    
                        option-text="codigoNomeAcao"
                        option-value="codAcao"
                        v-model="codAcao"
                        @input="$v.codAcao.$touch()"
                        :isDisabled="codProjeto == null"
                    ></model-list-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Valor total a ser rateado</label>
                    <money
                        v-model="valorTotal"
                        v-bind="money"
                        class="form-control text-right"
                        :disabled="true"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Valor disponível para rateio</label>
                    <money
                        v-model="valorDisponivelTemp"
                        v-bind="money"
                        class="form-control text-right"
                        :disabled="true"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>
                        Rateio Por:
                    </label>
                    <b-form-radio-group v-model="rateioPor">
                        <b-form-radio value="v">
                            <strong>VALOR</strong>
                        </b-form-radio>
                        <b-form-radio value="p">
                            <strong>PERCENTUAL</strong>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group
                    :state="$v.valor.$error ? false : null"
                    invalid-feedback="Valor deve ser maior que 0 e menor ou igual ao valor disponível"
                >
                    <label>Valor</label>
                    <money
                        v-model="valor"
                        v-bind="money"
                        class="form-control text-right"
                        :disabled="rateioPor != 'v'"
                        @input.native="$v.valor.$touch()"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group
                    :state="$v.valor.$error ? false : null"
                    invalid-feedback="O percentual deve gerar um valor maior que 0 e menor ou igual ao valor disponível"
                >
                    <label>Percentual</label>
                    <money
                        v-model="percentual"
                        v-bind="perc"
                        class="form-control text-right"
                        :disabled="rateioPor != 'p'"
                        @input.native="$v.percentual.$touch()"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="obrigatorioJustificativa">
            <b-col sm="12">
                <b-form-group>
                    <label>Justificativa</label>
                    <b-form-textarea
                        v-model="justificativaUABS"
                        :rows="3"
                        @input.native="
                            $v.justificativaUABS.$touch()
                        "
                        :state="
                            $v.justificativaUABS.$error
                                ? false
                                : null
                        "
                    ></b-form-textarea>
                    <b-form-invalid-feedback>
                        A justificativa é obrigatória
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModalDotacao()"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="$v.$invalid"
                @click.stop="confirmarSalvarDotacao()"
                class="ml-1"
                >Salvar</b-button
            >
        </div>
    </b-modal>
</template>

<script>
import { required, maxValue, minValue } from 'vuelidate/lib/validators'
import { ModelListSelect } from 'vue-search-select'

export default {
    props: {
        rateio: {
            type: Object,
            default: () => ({})
        },

        acao: {
            type: String,
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        valorTotal: {
            type: Number,
            default: () => 0
        },

        valorDisponivel: {
            type: Number,
            default: () => 0
        },

        unidades: {
            type: Array
        },

        projetos: {
            type: Array
        },
        
        acoes: {
            type: Array
        }
    },

    data() {
        return {
            mostrarModalDotacao: false,
            valorDisponivelTemp: 0,
            codUnidade: null,
            codProjeto: null,
            codAcao: null,
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            perc: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '%',
                precision: 5,
                masked: false
            },
            rateioPor: 'v',
            rateioPorOpcoes: [
                { value: 'v', text: 'Valor' },
                { value: 'p', text: 'Percentual' }
            ],
            percentual: 0,
            justificativaUABS: null
        }
    },

    methods: {
        obterUnidades() {
            this.$emit('obterUnidades')
        },

        obterProjetos() {
            let evento = {codUnidade: this.codUnidade}
            this.$emit('obterProjetos', evento)
        },

        obterAcoes() {
            let evento = {codUnidade: this.codUnidade, codProjeto: this.codProjeto}
            this.$emit('obterAcoes', evento)
        },

        fecharModalDotacao() {
            this.resetDotacao()
            this.$emit('modalFechado')
        },

        resetDotacao() {
            this.mostrarModalDotacao = false
            this.valorDisponivelTemp = 0
            this.erros = []
            this.codUnidade = null
            this.codProjeto = null
            this.codAcao = null
            this.valor = 0
            this.percentual = 0
            this.rateioPor = 'v'
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            if (this.acao == 'INSERIR') {
                this.obterUnidades()
                this.valorDisponivelTemp = this.valorDisponivel
                this.valor = this.valorDisponivelTemp
            }
            if (this.acao == 'ATUALIZAR') {
                this.valor = this.rateio.valor
                this.percentual = this.rateio.percentual
                this.valorDisponivelTemp = this.valorDisponivel + this.valor
            }
        },

        confirmarSalvarDotacao() {
            let rateioSalvar = {
                finalizar: this.finalizar,
                perfil: this.perfil,
                justificativa: null,
                rateio: null 
            }

            let html = `Confirma a ${
                this.acao == 'INSERIR' ? 'inserção' : 'atualização'
            } da dotação orçamentária?`

            if (rateioSalvar.finalizar) {
                html = `Confirma a ${
                    this.acao == 'INSERIR' ? 'inserção' : 'atualização'
                } da dotação orçamentária?
                <br/><br/>
                <div class="alert alert-danger" role="alert">
                    <div">
                        <h4>A confirmação dessa ação atualizará o rateio do item.</h4>
                    </div>
                </div>`
            }

            this.$swal({
                title: 'Rateios',
                html: html, 
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    if (rateioSalvar.perfil == 'UABS') {
                        rateioSalvar.justificativa = this.justificativaUABS
                    } 
                    this.salvarDotacao(rateioSalvar)    
                }
            })           
        },

        salvarDotacao(rateioSalvar) {
            this.$store.dispatch('addRequest')
            if (this.acao == 'ATUALIZAR') {
                let dotacaoDto = {
                    codUnidade: this.rateio.codUnidade,
                    nomeUnidade: this.rateio.unidade,
                    codProjeto: this.rateio.codProjeto,
                    nomeProjeto: this.rateio.projeto,
                    codAcao: this.rateio.codAcao,
                    nomeAcao: this.rateio.acao,
                    valor: this.valor
                }
                rateioSalvar.rateio = dotacaoDto
                this.$emit('atualizarRateio', rateioSalvar)
            } else {
                let dotacaoDto = {
                    codUnidade: this.codUnidade,
                    nomeUnidade: this.unidades.filter(u => {
                        return u.codUnidade == this.codUnidade
                    })[0].nome,
                    codProjeto: this.codProjeto,
                    nomeProjeto: this.projetos.filter(u => {
                        return u.codProjeto == this.codProjeto
                    })[0].nome,
                    codAcao: this.codAcao,
                    nomeAcao: this.acoes.filter(u => {
                        return u.codAcao == this.codAcao
                    })[0].nome,
                    valor: this.valor
                }
                rateioSalvar.rateio = dotacaoDto
                this.$emit('inserirRateio', rateioSalvar)
            }
            
            this.fecharModalDotacao()
            this.$store.dispatch('setRecarregar', true)
            this.$store.dispatch('removeRequest')
        },
    },

    watch: {
        mostrarModal() {
            this.mostrarModalDotacao = this.mostrarModal
        },

        codUnidade(newVal, oldVal) {
            if (newVal !== null && newVal !== '') {
                this.obterProjetos()
            } else {
                this.codUnidade = null
                this.codProjeto = null
            }
        },

        codProjeto(newVal, oldVal) {
            if (newVal !== null && newVal !== '') {
                this.obterAcoes()
            } else {
                this.codProjeto = null
                this.codAcao = null
            }
        },

        codAcao(newVal, oldVal) {
            if (newVal == '') {
                this.codAcao = null
            }
        },

        valor() {
            if (this.rateioPor == 'v') {
                this.percentual = (this.valor / this.valorTotal) * 100
            }
        },

        percentual() {
            if (this.rateioPor == 'p') {
                this.valor = (this.valorTotal * this.percentual) / 100
            }
        }
    },

    computed: {
        finalizar() {
            return this.valor == this.valorDisponivelTemp
        },
        
        perfil() {
            if (this.$route.name == 'DespesasGerais_Finalizacao_ItensDespesa_Detalhar') {
                return 'UABS'
            } else {
                return 'REQ'
            }
        },

        obrigatorioJustificativa() {
            return this.finalizar && this.perfil == 'UABS'
        }
    },

    validations: {
        codUnidade: {
            codUnidadeOk() {
                if (this.acao == 'INSERIR') {
                    return this.codUnidade != null
                }
                return true
            }
        },
        codProjeto: {
            codProjetoOk() {
                if (this.acao == 'INSERIR') {
                    return this.codProjeto != null
                }
                return true
            }
        },
        codAcao: {
            codAcaoOk() {
                if (this.acao == 'INSERIR') {
                    return this.codAcao != null
                }
                return true
            }
        },
        valor: {
            required,
            minValue: minValue(0.01),
            valorOk() {
                return this.valor <= this.valorDisponivelTemp
            }
        },

        percentual: {
            required,
            minValue: minValue(0.00001)
        },

        justificativaUABS: {
            obrigatorio() {
                if (this.obrigatorioJustificativa) {
                    return this.justificativaUABS != null && this.justificativaUABS != ''
                } else {
                    return true
                }
            }
        }
    },

    components: {
        ModelListSelect
    }
}
</script>
